import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { FiMenu, FiX, FiArrowUpRight } from 'react-icons/fi';

const links = [['About', 'About'], ['Experience', 'Experience'], ['Work', 'Project'], ['Stack', 'Skill']];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <nav className="nav__inner" aria-label="Main navigation">
        <Link to="Home" smooth duration={500} className="brand" onClick={() => setOpen(false)}>
          <span className="brand__mark">HS</span><span>Himanshu Singh</span>
        </Link>
        <div className={`nav__links ${open ? 'nav__links--open' : ''}`}>
          {links.map(([label, target]) => (
            <Link key={target} to={target} smooth duration={500} spy activeClass="is-active" onClick={() => setOpen(false)}>{label}</Link>
          ))}
          <Link to="Contact" smooth duration={500} className="nav__cta" onClick={() => setOpen(false)}>Let's talk <FiArrowUpRight /></Link>
        </div>
        <button className="nav__toggle" onClick={() => setOpen(!open)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open}>
          {open ? <FiX /> : <FiMenu />}
        </button>
      </nav>
    </header>
  );
}
